

































import { Component, Vue, Watch } from 'vue-property-decorator';
import Devbox from '@/components/devbox.vue';
import api from './services';
import query from '@/components/query/query-constructor';
import { throttle } from 'lodash';
import tutorial from '@/components/tutorial/tutorial';
import { ColumnsLocalStorageKey } from '@/services/columns';
import MainMenuGroupingMobileDropdown from '@/views/layout/navigation/grouping/main-menu-grouping-mobile-dropdown.vue';
import MainMenuReportTabsMobileDropdown from '@/views/layout/navigation/grouping/main-menu-report-tabs-mobile-dropdown.vue';
import { switchDesktopMobileView } from '@/routes/hooks/desktop-view-forced';
import AppNavbar from './views/layout/navbar.vue';
import AppContent from './views/layout/content.vue';
import AppBanners from '@/components/app-banners/app-banners.vue'
import Toast from '@/components/toast.vue'
import introJs from '@/components/tutorial/quickstart.vue';
import MainMenuMobileDrawer from '@/views/layout/navigation/main-menu-mobile-drawer.vue';
import AppExceptionsResolver from '@/components/app-exceptions-resolver/app-exceptions-resolver.vue';
import Dialogs from '@/components/dialogs/index.vue';
import GlobalLoaders from '@/components/global-loaders/global-loaders.vue';
import {logoutChatwootSession, syncChatwootUser} from '@/services/utils/chatwoot';
import { getIntercomBootPayload } from '@/services/utils/support-widget';

@Component({
  components: {
    Devbox,
    MainMenuGroupingMobileDropdown,
    MainMenuReportTabsMobileDropdown,
    AppNavbar,
    AppContent,
    Toast,
    AppBanners,
    introJs,
    AppExceptionsResolver,
    MainMenuMobileDrawer,
    Dialogs,
    GlobalLoaders,
  }
})
class App extends Vue {
  width: number = this.getWidth();

  get onWindowResizeThrottled() {
    return throttle(this.onWindowResize, 500);
  }

  get tutorial() {
    return tutorial(this);
  }

  get quickStartCondition() {
    return this.$store.state.tutorial.quickStart
      || this.$store.state.tutorial.quickStartStep
      || this.$store.state.tutorial.quickStartHiddenClass;
  }

  get showExceptionsResolver() {
    return this.$store.state.isAuthenticated
      && this.$route.name !== 'register-currency'
      && this.$route.name !== 'register-email-verification'
  }

  get isMobile() {
    return this.width < 960;
  }

  get quickStartHideCondition() {
    return this.isMobile && this.quickStartCondition;
  }

  /*SG
  @Watch('$route') -> body[data-view] = this.$route.name;
  */
  @Watch('$route')
  route_changed(value: any, oldValue: any) {
    this.$store.commit('setReportRoute', {
      name: value.name,
      type: value.params.type,
    })

    document.body.dataset.view = this.$route.name;
    if (this.$route.params.report) {
      this.$store.commit('tableSelectedReport', this.$route.params.report);
      // this.$store.commit('tableCurrentReport', this.$route.params.report && query.decode(this.$route.params.report).filterValues);
    } else {
      this.$store.commit('tableActiveTab', {
        tabId: 0,
        url: oldValue.path
      });
      this.$store.commit('tableTreeLevels', null);
    }
  }

  checkMobileView() {
    if(this.$store.state.mobile.desktopViewForced == null) {
      this.$store.commit('mobileDesktopViewForced', false);
    }
  }

  created() {
    if(this.$store.state.mobile.isMobile) {
      this.checkMobileView();
      switchDesktopMobileView(this.$store.state.mobile.desktopViewForced);
    } else {
      this.$store.commit('mobileDesktopViewForced', null);
    }
  }

      /*SG
#### modifies css selectors:
body[data-theme] = 'bemob'
body[data-view] =  CURRENT_ROUTE_NAME
  */
  private mounted() {
    api.$emit('render:start');
    document.body.dataset.theme = 'bemob';
    document.body.dataset.view = this.$route.name;

    if(!window.localStorage['auth-token']) {
      //localStorage.clear();

      const localStorageKeys = Object.keys(localStorage);
      localStorageKeys.forEach((key) => {
        if(key !== ColumnsLocalStorageKey) {
          localStorage.removeItem(key);
        }
      });
    }

    window.addEventListener('resize', this.onWindowResizeThrottled);
    // window.addEventListener('scroll', this.onBodyScrolledThrottledWindow);
    // document.body.addEventListener('scroll', this.onBodyScrolledThrottledBody);

  }

  private beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResizeThrottled);
    // window.removeEventListener('scroll', this.onBodyScrolledThrottledWindow);
    // document.body.removeEventListener('scroll', this.onBodyScrolledThrottledBody);
  }

  onBodyScrolledThrottledWindow() {
    this.onBodyScrolledThrottled('window');
  }

  onBodyScrolledThrottledBody() {
    this.onBodyScrolledThrottled('body');
  }

  get onBodyScrolledThrottled() {
    return throttle(this.onBodyScrolled, 1);
  }

  onBodyScrolled(event: any) {
    this.bus.emit('body-scrolled', event);
  }

  @Watch('quickStartHideCondition', { immediate: true })
  onQuickStartHideConditionChanged(value: boolean) {
    if(value) {
      this.tutorial.close();
      this.$store.commit('quickStart', false);
    }
  }

  @Watch('$store.state.table.chartOpen')
  onStoreStateTableChartOpen(value: boolean) {
    this.bus.emit('datatable-resizer-redraw', value);
  }

  getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }

  onWindowResize() {
    this.width = this.getWidth();
    document.documentElement.style.setProperty('--windowInnerHeight', window.innerHeight + 'px');
    //this.checkMobileView();
    this.bus.emit('window-resized');
  }

  get forceHeaderHideList() {
    return [
      'login.member',
      'login',
      'login.support',
      'two-factor',
      'register',
      'register-currency',
      'register-email-verification',
    ];
  }

  get isForceHeaderHide() {
    if(!this.$route.name) return true;
    return this.forceHeaderHideList.includes(this.$route.name)
  }

  get showPanel() {
    return !!this.$store.state.isAuthenticated
      && !!this.$store.state.isAuthorized
      && !this.isForceHeaderHide;
  }


  @Watch('$store.state.user')
  reloadIntercom(user: any, oldUser: any) {
    if (user?.id === oldUser?.id) {
      return;
    }

    if (user?.id) {
      if (this.$FF.chatwoot?.enabled) {
        void syncChatwootUser(user);
      } else {
        this.$intercom?.boot(getIntercomBootPayload(user));

        this.$intercom?.hide();
      }

      return;
    }

    if (this.$FF.chatwoot?.enabled) {
      logoutChatwootSession();
    } else {
      this.$intercom?.shutdown();
    }
  }
}
export default App;
